import { TimerAlert } from './TimerAlert';

export default TimerAlert;
